<template>
  <b-card
      header='Плательщик'
      header-tag="h4"
      bg-variant="light"
  >

  <b-row>
      <b-col cols="3">
        <div class="input-group">
          <b-form-select id="order_orderable_type"
                         :value="orderable_type_input.value"
                         @input="on_change_type"
                         :state="null"
                         :options="types"
                         trim>

          </b-form-select>
        </div>


      </b-col>
      <b-col cols="9">
        <template v-if="customer_type">
          <autosave-input
              :value="orderable_id_input.value"
              :params="orderable_id_input"
              :id="id"
              :index="0"
              :record_type="record_type"
              :url="url"
              @input="on_change"
              @on_save="save_type"
          />
        </template>

        <template v-if="entity_type">
          <autosave-input
              :value="entity_id_input.value"
              :params="entity_id_input"
              :id="id"
              :index="0"
              :record_type="record_type"
              :url="url"
              @input="on_change"
              @on_save="save_type"
          />
        </template>
      </b-col>

    </b-row>

  </b-card>
</template>

<script>
  import AutosaveInput from "../base/AutosaveInput";
  import {show_api_error} from "../shared/api_errors";
  export default {
    name: 'orderable',
    components: {AutosaveInput},
    props: ["id", "orderable_id", "orderable_type"],

    data() {
      return {
        record_type: 'order',
        selected_type: this.orderable_type,
        types: [
          {value: 'Entity', text: 'Юр. лицо'},
          {value: 'Customer', text: 'Физ. лицо'},
        ],
        entities_collection: [],
      }
    },

    computed: {
      orderable_type_input() {
        return {
          value: this.orderable_type,
          field: 'orderable_type',
          name: 'order[orderable_type]',
          label: null,
          type: 'text',
          mode: 'select',
          collection: this.types,
          has_error: false,
          error_hint: null,
          extra_data: {
            order_id: this.order_id,
          }
        };
      },
      orderable_id_input() {
        return {
          value: this.orderable_id,
          field: 'orderable_id',
          name: 'order[orderable_id]',
          label: null,
          type: 'text',
          mode: 'select2',
          one_word_search: true,
          get_options_url: '/customers',
          option_label: 'full_name',
          collection: this.orderable_collection,
          has_error: false,
          error_hint: null,
          extra_data: {
            orderable_type: this.selected_type,
          }
        };
      },

      entity_id_input() {
        return {
          value: this.orderable_id,
          field: 'orderable_id',
          name: 'order[orderable_id]',
          label: null,
          type: 'text',
          mode: 'select2',
          get_options_url: '/entities',
          option_label: 'name',
          collection: this.orderable_collection,
          has_error: false,
          error_hint: null,
          extra_data: {
            orderable_type: this.selected_type,
          }
        };
      },

      orderable_collection() {
        if (this.selected_type === 'Customer') {
          return this.$store.getters['orders/allCustomers'].concat(this.entities_collection);
        } else {
          return this.entities_collection;
          //return this.$store.getters['orders/allEntities'];
        }
      },

      customer_type() {
        return (this.selected_type === 'Customer');
      },

      entity_type() {
        return (this.selected_type === 'Entity');
      },

      url() {
        return this.id ? ('/orders/' + this.id) : '/orders'
      },

    },

    beforeMount() {
      if (this.orderable_id && this.orderable_type) {
        this.get_orderable();
      }
    },

    methods: {
      get_orderable() {
        let vc = this;
        let url;

        if (vc.entity_type)  {url = `/entities/${vc.orderable_id}`}
        if (vc.customer_type){url = `/customers/${vc.orderable_id}`}

        console.log('get data from :', url);
        $.ajax({
            url: url,
            dataType: "json",
            type: 'GET'
          })
          .done( function(data) {
            console.log('Успешно.', data);
            let item = data.data;
            let text = vc.entity_type ? item.attributes.name : item.attributes.full_name;
            vc.entities_collection.push({ text: text, value: item.id });
          })
          .fail( function(jqXHR) {
            show_api_error(vc, jqXHR);
          })

      },

      on_change() {},

      on_change_type(value) {
        console.log(value);
        this.$set(this, 'selected_type', value)
      },

      save_type() {
        // список доступных туристов зависит от плательщика — перечитываем состав заказа,
        // иначе в выборе остаются туристы, набранные при прежнем плательщике
        this.$store.dispatch('orders/getCustomerOrders', {order_id: this.id});
      },
    }
  }
</script>